(function () {
  'use strict';

  var WEBHOOK_URL = 'https://automation.ethicalhq.com/webhook/1b6b2ddb-6a38-488a-9709-44947e3223d5';
  var EMAILABLE_API_KEY = 'live_77cf6e9b8b568e336d63';
  var SUBMITTING_TEXT = 'Signing you up…';
  var turnstileWidgetId = null;

  /* =========================
     Init
  ========================== */
  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('collective-application-form');
    if (!form) return;

    var hasTurnstile = window.turnstile && window.TURNSTILE_SITE_KEY;

    if (hasTurnstile) {
      var container = form.querySelector('.turnstile-container');
      if (container) {
        turnstile.ready(function () {
          turnstileWidgetId = turnstile.render(container, {
            sitekey: window.TURNSTILE_SITE_KEY,
            size: 'invisible',
            execution: 'execute',
            action: 'collective_application',
            callback: onTurnstileSuccess,
            'error-callback': onTurnstileError
          });
        });
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        handleCollectiveApplication(form);
      }, true);

    } else {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        handleDirectSubmit(form);
      }, true);
    }
  });

  /* =========================
     Turnstile path
  ========================== */
  function handleCollectiveApplication(form) {
    var submitBtn = document.getElementById('btn-collective-application');
    var payload = collectFormData(form);

    if (!payload.company) { showStatus('error', 'Roastery name is required'); return; }
    if (!payload.website) { showStatus('error', 'Roastery URL is required'); return; }
    if (!payload.firstname) { showStatus('error', 'First name is required'); return; }
    if (!payload.lastname) { showStatus('error', 'Last name is required'); return; }
    if (!payload.email) { showStatus('error', 'Email address is required'); return; }
    if (!isValidEmailFormat(payload.email)) { showStatus('error', 'Please enter a valid email address'); return; }

    var agreementCheckbox = document.getElementById('CNC-Vendor-Agreement');
    if (!agreementCheckbox || !agreementCheckbox.checked) {
      showStatus('error', 'You must agree to the Vendor Agreement to continue.');
      return;
    }

    setLoading(submitBtn, true, SUBMITTING_TEXT);

    if (!turnstileWidgetId) {
      showStatus('error', 'Verification unavailable. Please refresh and try again.');
      setLoading(submitBtn, false);
      return;
    }

    turnstile.execute(turnstileWidgetId);
  }

  function onTurnstileSuccess(token) {
    var form = document.getElementById('collective-application-form');
    if (!form) return;

    var submitBtn = document.getElementById('btn-collective-application');
    var tokenInput = form.querySelector('[name="turnstile_token"]');
    if (tokenInput) tokenInput.value = token;

    submitForm(form, token, submitBtn);
  }

  function onTurnstileError() {
    showStatus('error', 'Verification failed. Please try again.');
    var submitBtn = document.getElementById('btn-collective-application');
    setLoading(submitBtn, false);
  }

  /* =========================
     Direct path (no Turnstile)
  ========================== */
  function handleDirectSubmit(form) {
    var submitBtn = document.getElementById('btn-collective-application');
    var payload = collectFormData(form);

    if (!payload.company) { showStatus('error', 'Roastery name is required'); return; }
    if (!payload.website) { showStatus('error', 'Roastery URL is required'); return; }
    if (!payload.firstname) { showStatus('error', 'First name is required'); return; }
    if (!payload.lastname) { showStatus('error', 'Last name is required'); return; }
    if (!payload.email) { showStatus('error', 'Email address is required'); return; }
    if (!isValidEmailFormat(payload.email)) { showStatus('error', 'Please enter a valid email address'); return; }

    var agreementCheckbox = document.getElementById('CNC-Vendor-Agreement');
    if (!agreementCheckbox || !agreementCheckbox.checked) {
      showStatus('error', 'You must agree to the Vendor Agreement to continue.');
      return;
    }

    setLoading(submitBtn, true, SUBMITTING_TEXT);
    submitForm(form, null, submitBtn);
  }

  /* =========================
     Core submit
  ========================== */
  function submitForm(form, token, submitBtn) {
    var payload = collectFormData(form);
    if (token) payload.turnstile_token = token;

    var agreementCheckbox = document.getElementById('CNC-Vendor-Agreement');
    payload['agreement-signed'] = !!(agreementCheckbox && agreementCheckbox.checked);
    payload['agreement-timestamp'] = new Date().toISOString();

    var redirectUrl = form.dataset.redirect || '/pages/thank-you-collective';

    validateWithEmailable(payload.email)
      .then(function (isValid) {
        if (!isValid) {
          throw new Error('Please check your email address and try again.');
        }
        return sendToWebhook(payload);
      })
      .then(function () {
        window.location.href = redirectUrl;
      })
      .catch(function (err) {
        showStatus('error', err.message || 'Something went wrong. Please try again.');
        setLoading(submitBtn, false);
        if (turnstileWidgetId) {
          try { turnstile.reset(turnstileWidgetId); } catch (e) {}
        }
      });
  }

  /* =========================
     Data collection
  ========================== */
  function collectFormData() {
    function getValue(id) {
      var el = document.getElementById(id);
      return el ? el.value.trim() : '';
    }

    var hutk = getHubspotUTK();
    var context = {
      pageUri: window.location.href,
      pageName: document.title
    };
    if (hutk) context.hutk = hutk;

    return {
      company: getValue('Roastery-Name'),
      website: getValue('Roastery-URL'),
      firstname: getValue('Roaster-First-Name'),
      lastname: getValue('Roaster-Last-Name'),
      email: getValue('Roaster-Email-Address'),
      user_type___roaster___cn: true,
      roaster_step: 'Collective',
      context: context
    };
  }

  /* =========================
     Webhook
  ========================== */
  function sendToWebhook(payload) {
    return fetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error('Submission failed. Please try again.');
    });
  }

  /* =========================
     Emailable
  ========================== */
  function validateWithEmailable(email) {
    if (!EMAILABLE_API_KEY) return Promise.resolve(true);

    return fetch(
      'https://api.emailable.com/v1/verify?email=' + encodeURIComponent(email) + '&api_key=' + EMAILABLE_API_KEY
    ).then(function (res) {
      if (!res.ok) return true;
      return res.json().then(function (data) {
        return data.state !== 'undeliverable';
      });
    }).catch(function () {
      return true;
    });
  }

  /* =========================
     HubSpot UTK
  ========================== */
  function getHubspotUTK() {
    var m = document.cookie.match(/hubspotutk=([^;]+)/);
    return m ? m[1] : '';
  }

  /* =========================
     Status message
  ========================== */
  function showStatus(type, message) {
    var el = document.getElementById('collective-form-status');
    if (!el) return;
    el.textContent = message;
    el.className = 'cn-form-status cn-form-status--' + type;
    el.style.display = 'block';
    el.setAttribute('role', 'alert');
  }

  function isValidEmailFormat(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  /* =========================
     Loading state
  ========================== */
  function setLoading(btn, state, text) {
    if (!btn) return;
    if (state) {
      btn.dataset.originalText = btn.textContent;
      btn.textContent = text || 'Sending…';
      btn.disabled = true;
      btn.style.opacity = '0.6';
      btn.style.pointerEvents = 'none';
    } else {
      btn.textContent = btn.dataset.originalText || 'Apply now';
      btn.disabled = false;
      btn.style.opacity = '1';
      btn.style.pointerEvents = 'auto';
    }
  }

})();
